export const city = [
  { label: "Ambon", value: "Ambon" },
  { label: "Balikpapan", value: "Balikpapan" },
  { label: "Banda Aceh", value: "Banda Aceh" },
  { label: "Bandar Lampung", value: "Bandar Lampung" },
  { label: "Bandung", value: "Bandung" },
  { label: "Banjar", value: "Banjar" },
  { label: "Banjarbaru", value: "Banjarbaru" },
  { label: "Banjarmasin", value: "Banjarmasin" },
  { label: "Batam", value: "Batam" },
  { label: "Batu", value: "Batu" },
  { label: "Bau Bau", value: "Bau Bau" },
  { label: "Bekasi", value: "Bekasi" },
  { label: "Bengkulu", value: "Bengkulu" },
  { label: "Bima", value: "Bima" },
  { label: "Binjai", value: "Binjai" },
  { label: "Bitung", value: "Bitung" },
  { label: "Blitar", value: "Blitar" },
  { label: "Bogor", value: "Bogor" },
  { label: "Bontang", value: "Bontang" },
  { label: "Bukittinggi", value: "Bukittinggi" },
  { label: "Cilegon", value: "Cilegon" },
  { label: "Cimahi", value: "Cimahi" },
  { label: "Cirebon", value: "Cirebon" },
  { label: "Denpasar", value: "Denpasar" },
  { label: "Depok", value: "Depok" },
  { label: "Dumai", value: "Dumai" },
  { label: "Gorontalo", value: "Gorontalo" },
  { label: "Gunung Sitoli", value: "Gunung Sitoli" },
  { label: "Jakarta Barat", value: "Jakarta Barat" },
  { label: "Jakarta Pusat", value: "Jakarta Pusat" },
  { label: "Jakarta Selatan", value: "Jakarta Selatan" },
  { label: "Jakarta Timur", value: "Jakarta Timur" },
  { label: "Jakarta Utara", value: "Jakarta Utara" },
  { label: "Jambi", value: "Jambi" },
  { label: "Jayapura", value: "Jayapura" },
  { label: "Kediri", value: "Kediri" },
  { label: "Kendari", value: "Kendari" },
  { label: "Kotamobagu", value: "Kotamobagu" },
  { label: "Kupang", value: "Kupang" },
  { label: "Langsa", value: "Langsa" },
  { label: "Lhokseumawe", value: "Lhokseumawe" },
  { label: "Lubuk Linggau", value: "Lubuk Linggau" },
  { label: "Madiun", value: "Madiun" },
  { label: "Magelang", value: "Magelang" },
  { label: "Makasar", value: "Makasar" },
  { label: "Malang", value: "Malang" },
  { label: "Manado", value: "Manado" },
  { label: "Mataram", value: "Mataram" },
  { label: "Medan", value: "Medan" },
  { label: "Metro", value: "Metro" },
  { label: "Mojokerto", value: "Mojokerto" },
  { label: "Padang Panjang", value: "Padang Panjang" },
  { label: "Padang Sidempuan", value: "Padang Sidempuan" },
  { label: "Padang", value: "Padang" },
  { label: "Pagar Alam", value: "Pagar Alam" },
  { label: "Palangkaraya", value: "Palangkaraya" },
  { label: "Palembang", value: "Palembang" },
  { label: "Palopo", value: "Palopo" },
  { label: "Palu", value: "Palu" },
  { label: "Pangkal Pinang", value: "Pangkal Pinang" },
  { label: "Pare Pare", value: "Pare Pare" },
  { label: "Pariaman", value: "Pariaman" },
  { label: "Pasuruan", value: "Pasuruan" },
  { label: "Payakumbuh", value: "Payakumbuh" },
  { label: "Pekalongan", value: "Pekalongan" },
  { label: "Pekan Baru", value: "Pekan Baru" },
  { label: "Pematang Siantar", value: "Pematang Siantar" },
  { label: "Pontianak", value: "Pontianak" },
  { label: "Prabumulih", value: "Prabumulih" },
  { label: "Probolinggo", value: "Probolinggo" },
  { label: "Sabang", value: "Sabang" },
  { label: "Salatiga", value: "Salatiga" },
  { label: "Samarinda", value: "Samarinda" },
  { label: "Sawhlunto", value: "Sawhlunto" },
  { label: "Semarang", value: "Semarang" },
  { label: "Serang", value: "Serang" },
  { label: "Sibolga", value: "Sibolga" },
  { label: "Singkawang", value: "Singkawang" },
  { label: "Solok", value: "Solok" },
  { label: "Sorong", value: "Sorong" },
  { label: "Subulussalam", value: "Subulussalam" },
  { label: "Sukabumi", value: "Sukabumi" },
  { label: "Sungai Penuh", value: "Sungai Penuh" },
  { label: "Surabaya", value: "Surabaya" },
  { label: "Surakarta", value: "Surakarta" },
  { label: "Tangerang Selatan", value: "Tangerang Selatan" },
  { label: "Tangerang", value: "Tangerang" },
  { label: "Tanjung Balai", value: "Tanjung Balai" },
  { label: "Tanjung Pinang", value: "Tanjung Pinang" },
  { label: "Tarakan", value: "Tarakan" },
  { label: "Tasikmalaya", value: "Tasikmalaya" },
  { label: "Tebing Tinggi", value: "Tebing Tinggi" },
  { label: "Tegal", value: "Tegal" },
  { label: "Ternate", value: "Ternate" },
  { label: "Tidore Kepulauan", value: "Tidore Kepulauan" },
  { label: "Tomohon", value: "Tomohon" },
  { label: "Tual", value: "Tual" },
  { label: "Yogyakarta", value: "Yogyakarta" },
];

export default city;
